module.exports = __webpack_public_path__ + "img/clockmaker.41906ffc.png";